// src/pages/Users/TechniquesQuizz/QuizControls.jsx
import React from "react";

export default function QuizControls({
  grades = [],
  grade,
  onGradeChange,
  includeSelfDefense,
  onToggleSelfDefense,
  disabled = false,
}) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 items-end">
      {/* Grade */}
      <div>
        <span className="block text-xs font-medium text-slate-600 dark:text-slate-300 mb-1">
          Sélectionnez votre grade
        </span>
        <select
          value={grade}
          onChange={(e) => onGradeChange?.(e.target.value)}
          className="select select-bordered w-full bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 border-slate-300 dark:border-slate-700"
          disabled={disabled}
        >
          {grades.map((g) => (
            <option key={g} value={g}>
              {g}
            </option>
          ))}
        </select>
      </div>

      {/* Self-Défense */}
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <span className="block text-xs font-medium text-slate-600 dark:text-slate-300 mb-1">
            Inclure la Self-Défense
          </span>
          <div className="flex items-center gap-3">
            <button
              type="button"
              role="switch"
              aria-checked={includeSelfDefense}
              onClick={onToggleSelfDefense}
              className={`relative inline-flex h-9 w-16 items-center rounded-full transition
                ${
                  includeSelfDefense
                    ? "bg-primary"
                    : "bg-slate-300 dark:bg-slate-700"
                }`}
            >
              <span
                className={`absolute left-1 top-1 h-7 w-7 rounded-full bg-white shadow transition-transform ${
                  includeSelfDefense ? "translate-x-7" : "translate-x-0"
                }`}
              />
              <span className="sr-only">Basculer Self-Défense</span>
            </button>
            <span className="text-sm text-slate-700 dark:text-slate-300">
              {includeSelfDefense ? "Activée" : "Désactivée"}
            </span>
          </div>
        </div>
      </div>

      {/* Hint */}
      <div className="text-xs text-slate-600 dark:text-slate-300">
        Les paramètres régénèrent un nouveau set de questions.
      </div>
    </div>
  );
}
